import { render, staticRenderFns } from "./Parceria_Sinecom.vue?vue&type=template&id=72afa0a2"
import script from "./Parceria_Sinecom.vue?vue&type=script&lang=js"
export * from "./Parceria_Sinecom.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Sinecom.vue?vue&type=style&index=0&id=72afa0a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports